import React, { useState } from 'react';
import { Modal, Form, Input, Button, message, Row, Col } from 'antd';
import { HomeOutlined, PhoneOutlined } from '@ant-design/icons';

const AddressEditModal = ({ visible, onClose, onAddressSubmit, currentAddress }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const formattedAddress = {
        zipCode: values.zipCode,
        city: values.city,
        countryCode: 'MX',
        addressLine: `${values.street} ${values.number}`,
        state: values.state,
        fullAddress: `${values.street} ${values.number}, ${values.neighborhood}, ${values.city}, ${values.state}, CP: ${values.zipCode}`,
        phone: values.phone,
        isTemporary: true
      };
      
      onAddressSubmit(formattedAddress);
      onClose();
      form.resetFields();
      message.success('Dirección actualizada correctamente');
    } catch (error) {
      message.error('Error al actualizar la dirección');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Editar dirección de envío"
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      width={600}
      destroyOnClose
      maskClosable={false}
      closable={false}
    >
      <div style={{ marginBottom: 16, padding: '12px', backgroundColor: '#e6f7ff', borderRadius: '8px' }}>
        <p style={{ color: '#1890ff', marginBottom: 0 }}>
          Ingresa la nueva dirección para calcular el costo de envío.
        </p>
      </div>
      
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={currentAddress ? {
          street: currentAddress.addressLine?.split(' ')[0] || '',
          number: currentAddress.addressLine?.split(' ')[1] || '',
          neighborhood: currentAddress.fullAddress?.split(',')[1]?.trim() || '',
          city: currentAddress.city || '',
          state: currentAddress.state || '',
          zipCode: currentAddress.zipCode || '',
          phone: currentAddress.phone || ''
        } : {}}
      >
        <Row gutter={16}>
          <Col span={16}>
            <Form.Item
              label="Calle"
              name="street"
              rules={[{ required: true, message: 'Ingresa la calle' }]}
            >
              <Input prefix={<HomeOutlined />} placeholder="Calle" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Número"
              name="number"
              rules={[{ required: true, message: 'Ingresa el número' }]}
            >
              <Input placeholder="Número" />
            </Form.Item>
          </Col>
        </Row>
        
        <Form.Item
          label="Colonia"
          name="neighborhood"
          rules={[{ required: true, message: 'Ingresa la colonia' }]}
        >
          <Input placeholder="Colonia" />
        </Form.Item>
        
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Código Postal"
              name="zipCode"
              rules={[
                { required: true, message: 'Ingresa el código postal' },
                { pattern: /^\d{5}$/, message: 'Código postal inválido (5 dígitos)' }
              ]}
            >
              <Input placeholder="Código Postal" maxLength={5} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Teléfono de contacto"
              name="phone"
              rules={[
                { required: true, message: 'Ingresa un teléfono de contacto' },
                { pattern: /^\d{10}$/, message: 'Teléfono inválido (10 dígitos)' }
              ]}
            >
              <Input prefix={<PhoneOutlined />} placeholder="Teléfono" maxLength={10} />
            </Form.Item>
          </Col>
        </Row>
        
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Ciudad"
              name="city"
              rules={[{ required: true, message: 'Ingresa la ciudad' }]}
            >
              <Input placeholder="Ciudad" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Estado"
              name="state"
              rules={[{ required: true, message: 'Ingresa el estado' }]}
            >
              <Input placeholder="Estado" />
            </Form.Item>
          </Col>
        </Row>
        
        <Form.Item>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
            <Button onClick={onClose}>
              Cancelar
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              Mandar a esta dirección
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddressEditModal;